module.exports = __webpack_public_path__ + "img/double-check-duo.f74928b6.svg";